import { Link, useParams, useNavigate } from "react-router-dom";
import { FileSignature, Scale, ShieldQuestion, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const Card = ({ to, title, desc, icon: I, testid, onClick }) => (
  <Link to={to} onClick={onClick} data-testid={testid}
    className="group bg-white rounded-2xl border border-slate-100 p-8 hover:border-[#0f4c5c] hover:-translate-y-1 transition shadow-[0_2px_10px_rgba(0,0,0,0.03)]">
    <div className="w-12 h-12 rounded-xl gradient-primary text-white flex items-center justify-center mb-5">
      <I className="w-6 h-6" />
    </div>
    <div className="font-heading text-xl font-semibold text-slate-900">{title}</div>
    <div className="text-sm text-slate-500 mt-2">{desc}</div>
  </Link>
);

export default function DocumentChoice() {
  const { id } = useParams();
  const navigate = useNavigate();

  const gerarHipo = async () => {
    try {
      const r = await api.post("/documents/generate", { type: "hipossuficiencia", client_id: id });
      toast.success("Declaração gerada");
      navigate(`/documents/${r.data.id}`);
    } catch (e) { toast.error("Erro ao gerar"); }
  };

  return (
    <div className="flex-1 min-w-0 flex flex-col p-6 lg:p-8 font-sans max-w-5xl mx-auto w-full">
      <button onClick={() => navigate(`/clients/${id}`)} className="text-sm text-slate-500 hover:text-slate-900 inline-flex items-center gap-1 mb-4">
        <ArrowLeft className="w-4 h-4" /> Voltar ao cliente
      </button>
      <h1 className="font-heading text-3xl font-semibold text-slate-900">O que você precisa criar?</h1>
      <p className="text-slate-500 mt-1">Os dados do cliente e do advogado serão preenchidos automaticamente.</p>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card to={`/clients/${id}/new-document/contrato`} testid="doc-contrato"
          title="Contrato de Honorários" icon={FileSignature}
          desc="Prestação de serviços advocatícios com objeto, valor e forma de pagamento." />
        <Card to={`/clients/${id}/new-document/procuracao`} testid="doc-procuracao"
          title="Procuração" icon={Scale}
          desc="AD JUDICIA ET EXTRA com poderes gerais e específicos opcionais." />
        <Card to="#" testid="doc-hipo" onClick={(e) => { e.preventDefault(); gerarHipo(); }}
          title="Declaração de Hipossuficiência" icon={ShieldQuestion}
          desc="Para gratuidade da justiça, art. 98 CPC / art. 5º LXXIV CF." />
      </div>
    </div>
  );
}
